/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".search-bar[_ngcontent-%COMP%]{display:flex;align-items:baseline}.search-bar__title[_ngcontent-%COMP%]{flex:1}.search-bar__input[_ngcontent-%COMP%]{flex:0;font-size:14px}.cards[_ngcontent-%COMP%]{margin-bottom:40px}"];
export { styles as styles };
